// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"31":"415d03fb2998c6a0","367":"94b347d3ff12845b","412":"38f457193f225e03","543":"0cd6ce6b09f9261a","667":"52f9b57f952cd426","755":"2b0f22c61c3f468b","775":"01c54f40944540ce"}[chunkId] + ".js";
};